import { Component, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ValidateService, DateService } from '../../services';

@Component({
  selector: 'app-range-date-picker',
  templateUrl: './range-date-picker.component.html',
  styleUrls: ['./range-date-picker.component.scss']
})
export class RangeDatePickerComponent {

  @Output() selectRange = new EventEmitter();
  public dateRangeForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private validateService: ValidateService,
    private dateService: DateService
  ) {
    this.dateRangeForm = this.fb.group({
      'fromDate': ['', [Validators.required, Validators.minLength(2)]],
      'toDate': ['', [Validators.required, Validators.minLength(2)]]
    });
  }

  public submitForm(e): void {
    if (this.dateRangeForm.valid) {

      const data = {
        fromDate: this.dateService.toModel(this.dateRangeForm.get('fromDate').value),
        toDate: this.dateService.toModel(this.dateRangeForm.get('toDate').value)
      };

      this.selectRange.emit(data);

    } else {
      this.validateService.validateAllFormFields(this.dateRangeForm);
      e.preventDefault();
      e.stopPropagation();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/range-date-picker/range-date-picker.component.ts